import React from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import DashCard from '../components/DashCard';
const TotaYearlylCostsPerCategory = _ref => {
  let {
    dashboardData,
    barTitles,
    dataFields
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    claim_costs_per_category: categoryCosts
  } = dashboardData;
  const barColors = ['#80bbdc', '#00b08b', '#a20a42', '#8b2885', '#684198',
  // '#00aeef',
  '#f0f2a6', '#aa6373'];
  const options = {
    chart: {
      type: 'line',
      height: 380
    },
    dataLabels: {
      enabled: false
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '35%',
        endingShape: 'flat',
        dataLabels: {
          enabled: true,
          position: 'top'
        }
      }
    },
    markers: {
      size: 3,
      colors: ['#00aeef']
    },
    stroke: {
      width: [0, 2],
      colors: ['#6dc6ff'],
      lineCap: 'round'
    },
    xaxis: {
      type: 'category'
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: '#393939',
          fontSize: '12px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        },
        formatter: number => window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(number)
      }
    },
    legend: {
      position: 'right',
      show: true,
      customLegendItems: barTitles,
      fontFamily: 'Franklin Gothic Book, sans-serif',
      labels: {
        colors: '#666E7E',
        useSeriesColors: false
      },
      markers: {
        fillColors: barColors
      }
    }
  };
  const categoriesBarsData = categoryCosts.map(yearCategoriesCosts => {
    return dataFields.map((fieldName, index) => {
      return {
        x: '',
        y: Math.round(yearCategoriesCosts[fieldName]),
        fillColor: barColors[index],
        name: fieldName
      };
    });
  }).flatMap(x => x);
  const benefitLineData = categoryCosts.map(yearCategoriesCosts => barTitles.map(title => {
    return {
      x: title,
      y: Math.round(yearCategoriesCosts.benefit_amount)
      // fillColor: barColors[5] 
    };
  })).flatMap(x => x);
  const benefitLine = [{
    name: 'Total Revenue',
    type: 'column',
    data: categoriesBarsData
  }, {
    name: 'Benefit',
    type: 'line',
    data: benefitLineData
  }];
  return /*#__PURE__*/React.createElement(DashCard, {
    title: t('chart_title_total_qualifying_expenditure_by_cost_category')
  }, /*#__PURE__*/React.createElement("div", {
    className: "total-sales",
    style: {
      height: '385px'
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: benefitLine,
    type: "bar",
    height: 385
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '10%',
      float: 'left',
      textAlign: 'center'
    }
  }, "\xA0"), categoryCosts.map((cc, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    style: {
      width: '30%',
      float: 'left',
      textAlign: 'center',
      color: '#666E7E'
    }
  }, cc.year)))));
};
export default TotaYearlylCostsPerCategory;